export const ACTIVE_REGION = 'ACTIVE_REGION';